import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from './store/store';
import Layout from './Component/Layout/Layout';
import Home from './Component/Home/Home';
import NotFound from './Component/NotFound/NotFound';
import MultiStepForm from './Component/RegistrationForm/MultiStepForm';
import './i18n';
import './App.css';

import ScrollToTop from './Component/ScrollToTop'; // Adjust path if needed
import ScrollToHash from './Component/ScrollToHash';
import TermsAndConditions from './Component/TermsAndConditions/TermsAndConditions';
import { Toaster } from 'react-hot-toast';

function App() {
  return (
    <Provider store={store}>
      <Router>
        <ScrollToTop /> 
        <ScrollToHash />
        <Toaster position="top-center" reverseOrder={false} />
        <div className="App">
          <Routes>
              <Route path="/" element={<Layout />}>
                <Route index element={<Home />} />
                <Route path="register" element={<MultiStepForm />} />
                  <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
                <Route path="*" element={<NotFound />} />
              </Route>
          </Routes>
        </div>
      </Router>
    </Provider>
  );
}

export default App;
